export * from './richart-life-map-page';
